// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"cbafe040","642":"0d60a4cf"}[chunkId] + ".chunk.js";
};